/** ------------------------------------------------------------------------- *
 * Glide.js Slider Plugin *
 * -------------------------------------------------------------------------- *
 * @module Slider
 * @desc initializes the Glide.js plugin
 */

/* global Glide */

const settings = {
    selector: '.js-slider',
    options: {
        autoplay: 5000,
        gap: 0,
        perView: 1,
        startAt: 0,
        type: 'carousel',
    },
};

/** ------------ *
 * Module Export *
 * ------------- *
 */

const Slider = {
    /**
     * @property Slider.selector
     * @desc The default DOMString selector for initializing the module
     */

    selector: settings.selector,

    /**
     * @property Slider.init
     * @method
     * @param {String} [selector] - The DOMString selector for the parent slider element(s)
     * @desc Intializes the module
     */

    init(selector = settings.selector) {
        const slider_els = document.querySelectorAll(selector);
        const slider_arr = Array.from(slider_els);

        slider_arr.forEach((slider_el) => {
            const slide_els = slider_el.querySelectorAll('.glide__slide');

            // Only initialize slider if there is more than one slide
            if (slide_els.length > 1) {
                new Glide(slider_el, settings.options).mount();
            }
        });
    },
};

export default Slider;
